import React from 'react';
import {Form, Input, Button, Row, Col, DatePicker, Tooltip} from 'antd';
import {InfoCircleOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {setFilterData} from "../../../store/filters/actions";
import moment from "moment";

const SearchForm = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filtersData);

  const onFinish = (values) => {
    console.log('Success:', values);

    for (let item in values) {
      if(values[item] === "" || values[item] === null ){
        delete values[item]
      }
    }


    if (values.dateDeath) {
      values.dateDeath = moment(values.dateDeath).format("YYYY-MM-DD");
    }

    if (values.dateBirth) {
      values.dateBirth = moment(values.dateBirth).format("YYYY-MM-DD");
    }


    dispatch( setFilterData(values, filters.page, filters.size))
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const Mock = {
    "dateBirth": "string",
    "dateDeath": "string",
    "firstName": "string",
    "middleName": "string",
    "lastName": "string",
    "ipn": "string",
    "passportNumber": "string",
    "passportSerial": "string",
  }

  return (
    <Form
      name="searchForm"
      // labelCol={{ span: 8 }}
      // wrapperCol={{ span: 16 }}
      // initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      className="search-form"
    >
      <Row gutter={24}>
        <Col md={6}>
          <Form.Item
            label="Прізвище"
            name="lastName"
            // rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label="Ім'я"
            name="firstName"
          >
            <Input allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label="По батькові"
            name="middleName"
          >
            <Input allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label="Дата народження"
            name="dateBirth"
          >
            <DatePicker allowClear={true} />
          </Form.Item>
        </Col>

      </Row>
      <Row gutter={24}>
        <Col md={6}>
          <Form.Item
            label="ІПН"
            name="ipn"
          >
            <Input  allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label="Серія паспорту"
            name="passportSerial"
          >
            <Input  allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={6}>
          <Form.Item
            label={
              <Tooltip title="Номер паспорту (або ID-картки)">
                <p style={{paddingTop:"0.9rem"}}>Номер паспорту <InfoCircleOutlined /></p>
              </Tooltip>
            }
            name="passportNumber"
          >
            <Input allowClear={true} />
          </Form.Item>
        </Col>

        <Col  md={6}>
          <Form.Item
            label={
              <Tooltip title="(померлий/БВО/ОЗБОО)">
                <span>Дата набуття статусу <InfoCircleOutlined /></span>
              </Tooltip>
            }
            name="dateDeath"
          >
            <DatePicker  allowClear={true} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>

        <Col span={2} md={22}>
        </Col>
        <Col span={1} md={2}>
          <Form.Item >
            <Button type="primary" htmlType="submit">
              Пошук
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchForm;